import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=03b53747&scoped=true&lang=css"
script.__scopeId = "data-v-03b53747"

export default script